import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import useAppStore from "@/store/appStore";
import { ReactNode } from "react";
import React from "react";

interface DialogFormProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  description?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const DialogForm: React.FC<DialogFormProps> = ({
  open,
  title,
  onClose,
  children,
  footer,
  description,
  size = "md"
}) => {
  const { direction } = useAppStore();
  
  const sizeClasses = {
    sm: "sm:max-w-md",
    md: "sm:max-w-lg",
    lg: "sm:max-w-2xl", 
    xl: "sm:max-w-4xl"
  };
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        aria-description={description}
        aria-describedby="dialog-description"
        className={`${sizeClasses[size]} max-h-[90vh] flex flex-col ${direction === 'rtl' ? "[&>button]:left-4 [&>button]:right-auto" : ""}`}
      >
        <DialogHeader className="flex-shrink-0">
          <DialogTitle className={direction === "rtl" ? "text-right" : ""}>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-hidden">
          {children}
        </div>
        {footer && (
          <div className="flex-shrink-0 mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
            {footer}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DialogForm;
